import React, { useState, useReducer, useEffect, useContext } from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from "query-string";
import moduleConfig from "./moduleConfig";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import ModuleDisplayBoolean from "../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDate from "../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import { confirmAndDeleteGeneral, confirmAndDisabledGeneral, confirmAndEnabledGeneral, loadItemsGeneral, resetFiltersGeneral, setFilterGeneral } from "../../../helpers/ModuleHelperFunctions";
import { listingReducer,listingInitialState } from "../../../reducers/module/listingReducer";
import Item from "./partials/listing/Item";

const DiscountCouponListing = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const { confirm } = useConfirm();
  const { search } = useLocation();
  let history = useNavigate();
  const [listingState, listingDispatch] = useReducer(listingReducer,listingInitialState);
  const [appliedFilters, setAppliedFilters] = useState(queryString.parse(search));

  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  const setFilter = (name, value) => {
   setFilterGeneral(name, value,appliedFilters,setAppliedFilters,history)
  }

  const resetFilters = () => {
    resetFiltersGeneral(appliedFilters,setAppliedFilters,history, moduleConfig);
  };

  const confirmAndDelete = async (id) => {
      let res = await confirmAndDeleteGeneral(id,`${moduleConfig.url}/${id}`,confirm,listingDispatch)

    if(res){
      loadItemsGeneral(listingDispatch,moduleConfig.url,search);
    }
  };

    const confirmAndDisabled = async (id) => {
      let res = await confirmAndDisabledGeneral(id,`${moduleConfig.url}/change-status`,confirm,listingDispatch)
      //console.log(res)
      if(res){
        loadItemsGeneral(listingDispatch,moduleConfig.url,search);
      }
    }; 
  
    const confirmAndEnabled = async (id) => {
      let res = await confirmAndEnabledGeneral(id,`${moduleConfig.url}/change-status`,confirm,listingDispatch)
      //console.log(res)
      if(res){
        loadItemsGeneral(listingDispatch,moduleConfig.url,search);
      }
    };

  
  useEffect(() => {
    loadItemsGeneral(listingDispatch,moduleConfig.url,search);
  }, [search]);

  useEffect(() => {
    setBreadcrumb([moduleConfig.breadcrumbs.listing]);
  }, []);






  return (
    <DashboardLayout>
      {listingState.isLoading && <OverlayLoading />}

      {listingState.status !== "fetching" && (
        <>
          {listingState.error && listingState.status === "fetchFailed" ? (
            <BlockErrorMessage error={listingState.error} />
          ) : (
            <>
              <ModuleHeader
                moduleTitle={moduleConfig.title}
                moduleUrl={moduleConfig.url}
              >
                {moduleConfig.buttons &&
                  moduleConfig.buttons.create === true && (
                    <>
                      <Link
                        to={`/${moduleConfig.url}/create`}
                        className="btn btn-custom-2 "
                      >
                        Create {moduleConfig.singleItemTitle}
                      </Link>

                    </>


                  )}
              </ModuleHeader>

              <div className="listingPage">
                {listingState.data &&
                  listingState.data.pagination &&
                  listingState.data.pagination.totalItems > 0 ? (
                  <>
                    {/* Search Area */}
                    <SearchArea
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                      appliedFilters={appliedFilters}
                      resetFilters={resetFilters}
                    />

                    {/* Listing */}
                    <section className="content listing ">
                      {listingState.error && (
                        <FormErrorMessage error={listingState.error} />
                      )}

                      {!listingState.data.items ||
                        listingState.data.items.length <= 0 ? (
                        <Alert className="alert-custom-1">
                          No records found with selected filters.{" "}
                          <Alert.Link href="#" className="text-custom-3" onClick={() => resetFilters()}>
                            <i className="fas fa-times text-custom-3" /> Reset Filters
                          </Alert.Link>
                          .
                        </Alert>
                      ) : (
                        <>
                          {listingState.data.items &&
                            listingState.data.items.length && (
                              <>
                                {listingState.data.items.map(
                                  (item, itemIndex) => {
                                    return (
                                      <Item
                                        moduleConfig={moduleConfig}
                                        item={item}
                                        key={itemIndex}
                                        
                                        confirmAndDisabled={confirmAndDisabled}
                                        confirmAndEnabled={confirmAndEnabled}
                                        customButtonsForItems={[]}
                                      />
                                    );
                                  }
                                )}
                              </>
                            )}
                        </>
                      )}
                    </section>

                    <ListingFooter
                      listingState={listingState}
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                    />
                  </>
                ) : (
                  <Alert className="alert-custom-1">No records found.</Alert>
                )}
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default DiscountCouponListing;
